import styled from 'styled-components';

export const AppWrapper = styled.div<{noPadding: boolean}>`
  padding: ${(props) => props.noPadding ? '' : '52px 0px'};
`;
